import { createContext } from 'react';

const defaultOnChange = () => {};

export const RadioContext = createContext({
    name: null,
    selected: null,
    disabled: false,
    onChange: defaultOnChange,
});